// Finalisierte & gehärtete Komponente
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MonoButton from "./MonoButton";
import PaperBG from "../kits/DesignKit/PaperBG";
import { useAuth } from "../auth/AuthContext";
import ICONS, { ICON_COLORS } from '../config/icon';
import UnderlineSketch from "./UnderlineSketch";
import PinnedNote from "../kits/DesignKit/PinnedNote";

const CourseDetailsAndRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { course } = location.state || {};
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    title: "",
    salutation: "",
    firstName: "",
    name: "",
    email: "",
    phone: "",
    course: course?.slug || "",
    companyAddress: "",
    street: "",
    city: "",
    postalCode: "",
    custom_date: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "Vorname ist erforderlich.";
    if (!formData.name) newErrors.name = "Nachname ist erforderlich.";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Bitte eine gültige E-Mail-Adresse eingeben.";
    if (!formData.phone || !/^\+?[0-9\s\-]{6,15}$/.test(formData.phone))
      newErrors.phone = "Du hast Deine Telefonnummer vergessen.";
    if (!formData.street) newErrors.street = "Straße ist erforderlich.";
    if (!formData.city) newErrors.city = "Stadt ist erforderlich.";
    if (!formData.postalCode || !/^\d{5}$/.test(formData.postalCode))
      newErrors.postalCode = "Bitte eine gültige Postleitzahl eingeben.";
    if (!formData.custom_date)
      newErrors.custom_date = "Bitte ein Startdatum auswählen.";
    else if (!/^\d{4}-\d{2}-\d{2}$/.test(formData.custom_date))
      newErrors.custom_date = "Bitte Datum im Format JJJJ-MM-TT wählen.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    setShowModal(false);

    if (!validateForm()) return;

    const courseSlug = typeof formData.course === "string"
      ? formData.course
      : formData.course?.slug || course?.slug || "";

    if (!courseSlug) {
      setErrorMessage("Fehler: Kurs-Slug konnte nicht erkannt werden.");
      return;
    }

   const isoDate = formData.custom_date.includes(".")
  ? formData.custom_date.split(".").reverse().join("-") // "30.05.2025" → "2025-05-30"
  : formData.custom_date;

    const requestData = {
  name: formData.name,
  email: formData.email,
  phone: formData.phone,
  street: formData.street,
  city: formData.city,
  postalCode: formData.postalCode,
  custom_date: isoDate, // ✅ fixiert
  companyAddress: formData.companyAddress || "",
  title: formData.title || "",
  salutation: formData.salutation || "",
  firstName: formData.firstName,
  registration_date: new Date().toISOString(),
  course: courseSlug,
};


    console.log("➡️ Gesendete Daten an PHP:", requestData);

    try {
      const response = await fetch("https://www.denisbitter.de/stage01/api/course_registrations_api.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      let data;
try {
  const text = await response.text();
  try {
    data = JSON.parse(text);
  } catch (jsonErr) {
    console.error("❌ Keine gültige JSON-Antwort:", text);
    throw new Error("Antwort war kein gültiges JSON.");
  }
} catch (err) {
  console.error("❌ Fehler beim Laden:", err);
  setErrorMessage("Serverantwort konnte nicht verarbeitet werden.");
  return;
}


      if (response.ok && data.success) {
        const userToken = btoa(data.userId.toString());
        login(userToken, data.userId);
        navigate("/success", { state: { formData, course } });
      } else {
        if (data.message === "Kurs bereits registriert." && data.userId) {
          const userToken = btoa(data.userId.toString());
          login(userToken, data.userId);
          navigate("/dashboard");
        } else {
          setErrorMessage(data.message || "Fehler bei der Anmeldung.");
        }
      }
    } catch (error) {
      console.error("❌ Netz- oder Parsingfehler:", error);
      setErrorMessage("Netzwerkfehler oder ungültige Antwort. Bitte später erneut versuchen.");
    }
  };

  if (!course) {
    return <p className="text-center mt-6">Keine Kursdetails verfügbar.</p>;
  }

  const Icon = ICONS[course?.icon] || ICONS.default;
  const colorClass = ICON_COLORS[course.icon] || ICON_COLORS.default;




  return (
    <PaperBG>
    <div className="container mx-auto px-4 sm:px-6 py-12 font-mono">
      {/* Kursdetails */}
      <div className="bg-white p-6 rounded-lg shadow-lg mb-10 ">
  {/* Titelzeile mit Icon + Titel nebeneinander */}
  <div className="flex items-center gap-2 mb-4">
    {Icon && <Icon className={`w-6 h-6 ${colorClass}`} />}
    <h2 className="text-xs sm:text-xl font-mono font-bold">
      {course.title}
    </h2>
  </div>

  <p className="text-gray-700 mb-2 text-xs max-w-screen-sm sm:text-left">
  {course.description}
</p>

  <div className="max-w-screen-sm">
    <UnderlineSketch />
  </div>
<div className="grid grid-cols-1  gap-x-8 gap-y-2 py-6 text-xs text-gray-500 font-mono">
  <div>
    <span className="block text-gray-400">Startdatum:</span>
    <span className="text-black">{ "sofort möglich"}</span>
  </div>
  <div>
    <span className="block text-gray-400">Preis vor Ort:</span>
    <span className="text-black">{course.price ? `${course.price} €` : "Preis auf Anfrage"}</span>
  </div>
  <div>
    <span className="block text-gray-400">Preis Online:</span>
    <span className="text-black">{course.priceOnline ? `${course.priceOnline} €` : "Preis auf Anfrage"}</span>
  </div>
</div>

</div>


      {/* Anmeldeformular */}
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-lg space-y-6 focus:marker:outline-none text- sm:text-base"
      >
        {/* Vorname */}
        <div>
          <label className="block text-xs font_mono">Vorname</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            className="text-xs  mt-1 block w-full px-4 py-2 border rounded-md focus-within:ring-1 focus-within:ring-gray-800 outline-none"
          />
          {errors.firstName && (
            <p className="text-red-500 text-sm">{errors.firstName}</p>
          )}
        </div>

        {/* Nachname */}
        <div>
          <label className="block text-xs font_mono">Nachname</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className=" text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
        </div>

        {/* E-Mail */}
        <div>
          <label className="block text-xs font_mono">E-Mail</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
        </div>

        {/* Telefonnummer */}
        <div>
          <label className="block text-xs font_mono">Telefonnummer</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.phone && (
            <p className="text-red-500 text-sm">{errors.phone}</p>
          )}
        </div>

        {/* Straße */}
        <div>
          <label className="block text-xs font_mono">Straße</label>
          <input
            type="text"
            name="street"
            value={formData.street}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.street && (
            <p className="text-red-500 text-sm">{errors.street}</p>
          )}
        </div>

        {/* Stadt */}
        <div>
          <label className="block text-xs font_mono">Stadt</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.city && <p className="text-red-500 text-sm">{errors.city}</p>}
        </div>

        {/* Postleitzahl */}
        <div>
          <label className="block text-xs font_mono">PLZ</label>
          <input
            type="text"
            name="postalCode"
            value={formData.postalCode}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md outline-none focus-within:ring-1 focus-within:ring-gray-800"
          />
          {errors.postalCode && (
            <p className="text-red-500 text-sm">{errors.postalCode}</p>
          )}
        </div>

        {/* Datum */}
        <div>
          <label className="block text-xs font_mono text-black">Wann willst du starten</label>
          <input
            type="date"
            name="custom_date"
            value={formData.custom_date}
            onChange={handleInputChange}
            className="text-xs mt-1 block w-full px-4 py-2 border rounded-md focus-within:ring-1 focus-within:ring-gray-800 outline-none"
          />
          {errors.custom_date && (
            <p className="text-red-500 text-sm">{errors.custom_date}</p>
          )}
        </div>
        <MonoButton className="w-full h-10 text-center text-xs" type="submit">
          Melde mich unverbindlich an 

          </MonoButton>
        {/* Submit-Button */}
      
      </form>

      {showModal && (
  <div className="text-xs mt-6 bg-yellow-100 border border-orange-300 text-yellow-700 px-4 py-3 rounded">
    Du bist bereits für diesen Kurs registriert.
  </div>
)}

      {successMessage && (
        <p className="mt-4 text-orange-300 bg-gray-900 text-center font-bold">
          {successMessage}
        </p>
      )}
      {errorMessage && (
        <p className="mt-4 text-red-500 text-center font-medium">{errorMessage}</p>
      )}
    </div>
    </PaperBG>
  );
};

export default CourseDetailsAndRegistration;